import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/htx/lab-procedures/t4";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	t4: {
		id: "form.t4",
		defaultMessage: "T4"
	},
	value: {
		id: "form.t4.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "t4",
	value: {
		title: messages.t4,
		validator,
		fieldset,
		isImportant: true
	}
};
